var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRolka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .blueprint_een{fill:#111918;} .st0{fill:#111918;} "), /*#__PURE__*/React.createElement("path", {
    className: "blueprint_een",
    d: "M8,13c0.705,0,2-0.519,2-3S8.705,7,8,7s-2,0.519-2,3S7.295,13,8,13z M8,8c0.483,0,1,0.525,1,2 s-0.517,2-1,2c-0.483,0-1-0.525-1-2S7.517,8,8,8z M24,1H8c-3.86,0-7,4.037-7,9c0,4.963,3.14,9,7,9h4v11c0,0.552,0.448,1,1,1h17 c0.552,0,1-0.448,1-1V10C31,5.037,27.86,1,24,1z M8,3c2.757,0,5,3.14,5,7s-2.243,7-5,7s-5-3.14-5-7S5.243,3,8,3z M13,14.419V17 h-2.098C11.748,16.376,12.467,15.488,13,14.419z M29,19h-1v1h1v9H14v-9h1v-1h-1v-9h1V9h-1.052c-0.243-2.586-1.407-4.79-3.046-6H24 c2.514,0,4.594,2.613,4.943,6H28v1h1V19z M16,9h1v1h-1V9z M18,9h1v1h-1V9z M20,9h1v1h-1V9z M22,9h1v1h-1V9z M24,9h1v1h-1V9z M26,9h1 v1h-1V9z M16,19h1v1h-1V19z M18,19h1v1h-1V19z M20,19h1v1h-1V19z M22,19h1v1h-1V19z M24,19h1v1h-1V19z M26,19h1v1h-1V19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolka);
export default __webpack_public_path__ + "static/media/rolka.5bf2450ab1ef5bec33133bee97e70ead.svg";
export { ForwardRef as ReactComponent };